import { render } from "./IconMagic.vue?vue&type=template&id=006f23f0"
import script from "./IconMagic.vue?vue&type=script&lang=ts"
export * from "./IconMagic.vue?vue&type=script&lang=ts"
script.render = render

export default script